import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FaqExpandable, { Faq } from './FaqExpandable';
import _ from 'lodash';

interface IProps {
    className?: string;
}

const FAQS: Faq[] = _.range(1, 10).map(id => {
    return {
        id,
        question: `dashboard.faq.question-${id}`,
        answer: `dashboard.faq.answer-${id}`,
        expanded: false
    }
});

export default function StudentFaq(props: IProps) {
    const { t } = useTranslation();
    const [faqs, setFaqs] = useState(FAQS);

    const onOpen = (id: number) => {
        const f = faqs.map(x => {
            return { ...x, expanded: false }
        })

        setFaqs(f);

        const target = faqs.find(x => x.id === id);
        if (!target) {
            return
        }

        if (target.expanded) {
            return;
        }

        const immediatelyOpen = !faqs.some(x => x.expanded);

        const timeout = immediatelyOpen ? 0 : 200;

        setTimeout(() => {
            const f = faqs.map(x => {
                return { ...x, expanded: x.id === id }
            })

            setFaqs(f);
        }, timeout);
    }

    return (
        <div className={"faq " + props?.className}>
            <div className='faq-header'>{t('dashboard.faq.header')}</div>
            <div className='faq-list'>
                {faqs.map(x => <FaqExpandable key={x.id} faq={x} onOpen={onOpen} />)}
            </div>
        </div>
    )
}